import React from 'react';
import Select, { GroupBase, Props } from 'react-select';
import overriddenSelectComponents from './override';
import { getSelectStyles } from './styles';
import { SelectOption } from './types';
import { useModalMenuPortal } from './use-modal-menu-portal';

export type UDSelectProps<isMulti extends boolean = boolean, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>> = Omit<
  Props<SelectOption, isMulti, Group>,
  'hideSelectedOptions' | 'styles'
> & {
  divProps?: React.HTMLAttributes<HTMLDivElement>;
  hasError?: boolean;
  /** Поиск по пунктам вводом в поле. По умолчанию выключен: длинный список с загрузкой — это `UDAsyncSelect`. */
  isSearchable?: boolean;
};

export const UDSelect = <isMulti extends boolean = false, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>>(
  props: UDSelectProps<isMulti, Group>,
) => {
  const { components, divProps, isDisabled, isSearchable = false, ...restProps } = props;

  const styles = getSelectStyles<isMulti, Group>();
  const modalMenuProps = useModalMenuPortal();
  const selectComponents = components || overriddenSelectComponents;

  return (
    <div
      {...divProps}
      onClick={(e) => e.stopPropagation()}
      style={{ cursor: isDisabled ? 'not-allowed' : undefined, ...divProps?.style }}
    >
      <Select
        {...modalMenuProps}
        {...restProps}
        isDisabled={isDisabled}
        data-error={restProps.hasError}
        hideSelectedOptions={false}
        placeholder={restProps.placeholder || ''}
        closeMenuOnSelect={!restProps.isMulti}
        isSearchable={isSearchable}
        styles={styles}
        components={selectComponents}
      />
    </div>
  );
};
